import SDL from '../styles/fonts/s_display_l.woff'

export default { SDL }